import Connect from '../../../Connect/Connect';
import { connectorFlow } from '../../../Connect/Connect';

// IH-3579 / IH-1601 / IH-2014: these calls no longer send credentials or endpoint URLs.
// The server decrypts them from tenant_login.protected_fields, so the browser only names the
// action it wants. `integrationAppId` scopes the request to a connector setting.
export const getZuoraWorkdayMappings = async (
  integrationAppId: number,
  type: string = 'summary'
) => {
  const result = { workdayFields: [], zuoraFields: [] };
  try {
    const response = await connectorFlow('get_zr_wd_mappings', integrationAppId, { type });
    result.workdayFields = response['workdayFields'];
    result.zuoraFields = response['zuoraFields'];
  } catch (error) {
    Connect.log(error);
  }
  return result;
};

export const validateZuoraWorkday = async (integrationAppId: number) => {
  const result = {
    workday: {
      isValid: false,
      status: 200,
      statusText: ''
    },
    zuora: {
      isValid: false,
      status: 200,
      statusText: ''
    }
  };
  try {
    const response = await connectorFlow('validate_zr_wd', integrationAppId);
    result.workday = response['workday'];
    result.zuora = response['zuora'];
  } catch (error) {
    Connect.log(error);
  }
  return result;
}

export const buildWorkdayBillingGlobalConstants = (auth: {
  WDB_SERVICE_URL: string;
  WDB_USERNAME_GET: string;
  WDB_PASSWORD_GET: string;
  WDB_USERNAME_PUT: string;
  WDB_PASSWORD_PUT: string;
  WDB_ZR_CLIENT_ID: string;
  WDB_ZR_CLIENT_SECRET: string;
}, emailNotifications: {
  enabled: boolean;
  failures: boolean;
  success: boolean;
  emails: string[];
}, fieldMappings: any, envRestEndpoint: string, newGlobalConstants: any) => {
  // build field mappings
  let mappings = {};
  const reportType = fieldMappings['reportType'] || 'summary';
  const mappingKeys = Object.keys(fieldMappings);
  if (mappingKeys.length > 0) {
    for (let key of mappingKeys) {
      if (key.startsWith('z-')) {
        const rawMappings = fieldMappings[key]?.[reportType]?.['mappings'] || {};
        const rawMappingKeys = Object.keys(rawMappings);
        if (rawMappingKeys.length > 0) {
          for (let rmKey of rawMappingKeys) {
            const mapping = rawMappings[rmKey];
            const key = mapping['source']['text'];
            const value = mapping['target']['text'];
            mappings[key] = value;
          }
        }
      }
    }
  }

  // build email configs
  let emailConfig = {};
  if (emailNotifications.enabled) {
    emailConfig = {
      'Failures': emailNotifications.failures || false,
      'Success': emailNotifications.success || false,
      'Emails': emailNotifications.emails || []
    };
  }

  // store tenant information to Workflow Global Constants to be used in email notification
  const connect: Connect = (window as any).connect;
  const lastHyphenIndex = connect.tenant?.slug ? connect.tenant.slug.lastIndexOf('-') : -1;
  const host = lastHyphenIndex !== -1 ? connect.tenant.slug.substring(0, lastHyphenIndex) : '';
  const entity = lastHyphenIndex !== -1 ? connect.tenant.slug.substring(lastHyphenIndex + 1) : '';
  let environment = '';

  if (host.includes('staging')) {
    environment = 'Staging';
  } else if (host.includes('sandbox')) {
    environment = 'Sandbox';
  } else if (host.includes('test')) {
    environment = 'Test';
  } else if (host.includes('preprod')) {
    environment = 'Preprod';
  } else if (host.includes('na')) {
    environment = 'NA Production';
  } else if (host.includes('eu')) {
    environment = 'EU Production';
  } else if (host.includes('www.zuora.com') || host.includes('zuora.com')) {
    environment = 'Production';
  } else {
    environment = 'Development';
  }

  if (newGlobalConstants) {
    return {
      global_constants: [
        { key: "WDB_SERVICE_URL", value: auth.WDB_SERVICE_URL, secret: false },
        { key: "WDB_USERNAME_GET", value: auth.WDB_USERNAME_GET, secret: false },
        { key: "WDB_PASSWORD_GET", value: auth.WDB_PASSWORD_GET, secret: true },
        { key: "WDB_USERNAME_PUT", value: auth.WDB_USERNAME_PUT, secret: false },
        { key: "WDB_PASSWORD_PUT", value: auth.WDB_PASSWORD_PUT, secret: true },
        { key: "WDB_ZR_CLIENT_ID", value: auth.WDB_ZR_CLIENT_ID, secret: true },
        { key: "WDB_ZR_CLIENT_SECRET", value: auth.WDB_ZR_CLIENT_SECRET, secret: true },
        { key: "WDB_ZR_REST_ENDPOINT", value: envRestEndpoint, secret: false },
        { key: "WDB_MAPPINGS", value: JSON.stringify(mappings), secret: false },
        { key: "WDB_EMAIL_CONFIG", value: JSON.stringify(emailConfig), secret: false },
        { key: "WDB_ACTION_TYPE", value: reportType, secret: false },
        { key: "WDB_ENVIRONMENT", value: environment, secret: false },
        { key: "WDB_TENANT_ID", value: connect.tenant.tenant_id || entity || 'Unknown', secret: false },
        { key: "WDB_TENANT_NAME", value: connect.tenant.name || 'Unknown', secret: false },
        { key: "WDB_ENTITY_ID", value: entity || 'Unknown', secret: false }
      ]
    };
  }

  return {
    "WDB_SERVICE_URL": auth.WDB_SERVICE_URL,
    "WDB_USERNAME_GET": auth.WDB_USERNAME_GET,
    "WDB_PASSWORD_GET": auth.WDB_PASSWORD_GET,
    "WDB_USERNAME_PUT": auth.WDB_USERNAME_PUT,
    "WDB_PASSWORD_PUT": auth.WDB_PASSWORD_PUT,
    "WDB_ZR_CLIENT_ID": auth.WDB_ZR_CLIENT_ID,
    "WDB_ZR_CLIENT_SECRET": auth.WDB_ZR_CLIENT_SECRET,
    "WDB_ZR_REST_ENDPOINT": envRestEndpoint,
    "WDB_MAPPINGS": JSON.stringify(mappings),
    "WDB_EMAIL_CONFIG": JSON.stringify(emailConfig),
    "WDB_ACTION_TYPE": reportType,
    "WDB_ENVIRONMENT": environment,
    "WDB_TENANT_ID": connect.tenant.tenant_id || entity || 'Unknown',
    "WDB_TENANT_NAME": connect.tenant.name || 'Unknown',
    "WDB_ENTITY_ID": entity || 'Unknown'
  };
};